var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "TcAppointmentFormSuccess inline-block bg-white rounded-xl text-left overflow-hidden shadow-xl transform transition-all align-middle max-w-xl w-full px-9"
    },
    [
      _c("div", { staticClass: "py-10" }, [
        _c("div", { staticClass: "flex flex-col items-center" }, [
          _c(
            "div",
            {
              staticClass:
                "mx-auto flex-shrink-0 flex items-center justify-center h-16 w-16 rounded-full bg-success text-white"
            },
            [
              _c(
                "svg",
                {
                  staticClass: "h-10 w-10",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M5 13l4 4L19 7"
                    }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "w-full max-w-sm mt-10 btn-success",
              on: {
                click: function($event) {
                  return _vm.$parent.setPage(
                    _vm.$root.user ? "events-my-calendar" : "welcome"
                  )
                }
              }
            },
            [_vm._v("Continuar")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "w-full max-w-sm mt-5 btn-secondary",
              on: {
                click: function($event) {
                  return _vm.$root.logOut()
                }
              }
            },
            [_vm._v("Cerar sesión")]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "mt-10 text-2xl text-center" }, [
      _vm._v("Su inscrición"),
      _c("br"),
      _vm._v("se ha realizado correctamente")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "mt-5 text-gray-500 text-center" }, [
      _vm._v("Para realizar el pago acuda al "),
      _c("strong", [_vm._v("Departamento de Administración")]),
      _vm._v(" y confirme la inscripción")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }